/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 495);
/******/ })
/************************************************************************/
/******/ ({

/***/ 3:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/**

 * JavaScript functions for SIW_IPP_LGN.HTS - v1.0 Chris Salt
 * 11/03/2014
 */



__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {

    var handleSitsErrors = void 0;
    var toggleNewUser = void 0;

    /*********************************************************************/
    /* FUNCTION DECLARATIONS                                             */
    /*********************************************************************/

    //Handle errors generated by the server to highlight fields
    handleSitsErrors = function handleSitsErrors() {

        //Find specific known error codes and highlight fields as necessary
        var messageCode = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.sv-message-box').text();

        //SITS_LOGIN_ERROR_002 - Invalid username error
        if (messageCode.search('SITS_LOGIN_ERROR_002') !== -1) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#usernameGroup').addClass('has-error');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#usernameGroup').find('.form-control-feedback i').addClass('fa fa-warning');
        }

        //SITS_LOGIN_ERROR_003 - password error
        if (messageCode.search('SITS_LOGIN_ERROR_003') !== -1) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#passwordGroup').addClass('has-error');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#passwordGroup').find('.form-control-feedback i').addClass('fa fa-warning');
        }

        //SITS_LOGIN_ERROR_004 - Incorrect username/password error
        if (messageCode.search('SITS_LOGIN_ERROR_004') !== -1) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#usernameGroup').addClass('has-error');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#usernameGroup').find('.form-control-feedback i').addClass('fa fa-warning');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#passwordGroup').addClass('has-error');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#passwordGroup').find('.form-control-feedback i').addClass('fa fa-warning');
        }
    };

    //Hide new user section if necessary - look at whether sits creates submit button
    toggleNewUser = function toggleNewUser() {
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#NEW_USER').length < 1) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#new_user_section').hide();
        }
    };

    /*********************************************************************/
    /* EVENTS                                                            */
    /*********************************************************************/
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#ippLgnForm').on('submit', function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loadingModal').modal({
            backdrop: 'static',
            keyboard: false
        });
    });

    /*********************************************************************/
    /* RUN                                                               */
    /*********************************************************************/
    handleSitsErrors();
    toggleNewUser();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#MUA_CODE').focus();
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// ku/js/siw_ipp_lgn.js